import { cn } from '@/registry/reapit/lib/utils'

function Kbd({ className, ...props }: React.ComponentProps<'kbd'>) {
  // DS has no explicit Kbd page — kept as a Reapit extension.
  // Small neutral pill: muted bg, muted-foreground text, rounded-md (4 px) radius, xs text.
  return (
    <kbd
      data-slot="kbd"
      className={cn(
        'pointer-events-none inline-flex h-5 w-fit min-w-5 items-center justify-center gap-1 rounded-md border border-border/50 bg-muted px-1.5 font-sans text-xs font-medium text-muted-foreground select-none',
        "[&_svg:not([class*='size-'])]:size-3",
        // Inside tooltip: invert colours so it reads on the dark tooltip surface
        '[[data-slot=tooltip-content]_&]:border-transparent [[data-slot=tooltip-content]_&]:bg-background/20 [[data-slot=tooltip-content]_&]:text-background dark:[[data-slot=tooltip-content]_&]:bg-background/10',
        className,
      )}
      {...props}
    />
  )
}

function KbdGroup({ className, ...props }: React.ComponentProps<'div'>) {
  return <kbd data-slot="kbd-group" className={cn('inline-flex items-center gap-1', className)} {...props} />
}

export { Kbd, KbdGroup }
